// Variant picker: matches the checked option chips to a variant and updates id, price and button.
(function () {
  function money(cents) {
    var d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var data = root.querySelector('[data-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var price = root.querySelector('[data-price]');
    var add = root.querySelector('[data-add]');
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-index]')) return;
      var picked = [];
      root.querySelectorAll('[data-option-index]:checked').forEach(function (r) {
        picked[+r.dataset.optionIndex] = r.value;
      });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === picked[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (price) price.textContent = money(match.price);
      if (add) {
        add.disabled = !match.available;
        add.textContent = match.available ? 'Add to order' : 'Sold out';
      }
    });
  });

  var copy = document.querySelector('[data-copy-email]');
  if (copy) {
    copy.addEventListener('click', function () {
      var addr = document.querySelector('[data-email]');
      var msg = document.querySelector('[data-copied]');
      var t = addr.textContent.trim();
      function sel() {
        var r = document.createRange(); r.selectNodeContents(addr);
        var s = getSelection(); s.removeAllRanges(); s.addRange(r);
        msg.textContent = 'Selected. Press Ctrl+C or Cmd+C to copy.';
      }
      try { navigator.clipboard.writeText(t).then(function () { msg.textContent = 'Copied: ' + t; }, sel); }
      catch (err) { sel(); }
    });
  }
})();
